<div class="flex flex-col m-0 p-0">
    @for (link of links; track link.label) {
    <a [routerLink]="link.route" routerLinkActive="active-link" class="p-4" (click)="navigate.emit(link.route)">
        {{ link.label | translate }}
    </a>
    }
</div>
